import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import SlidingPanel from 'react-sliding-side-panel'
import { HintText, SmallHintText } from 'src/components/atoms/configurator'
import {
  HighlightInBox,
  VerticalAlignWrapper
} from 'src/components/containers/configurator/ConfiguratorBox'
import ListOfProducts from 'src/components/molecules/configurator/ListOfProducts'
import Accordion from 'src/components/containers/Accordion'
import Link from 'src/components/atoms/input/buttons/Link'
import Star from 'src/components/atoms/configurator/Star'
import {
  Financing,
  FinancingProvision
} from 'src/components/molecules/configurator/Financing'
import PhoneNumber from 'src/components/atoms/PhoneNumber'
import { media } from '../../../utils'

const NumberFormat = require('react-number-format')

const bestPriceGuaranteed = require('src/assets/configurator/bestpreis_v2.png')
const funeralHomeCertificate = require('src/assets/wizard/funeralHomeCertificate.png')
const trustedShop = require('src/assets/redesign/trusted_shops_logo.png')

@inject('confStore')
@observer
export class MobileConfiguratorOverview extends React.Component<any> {
  componentDidMount() {
    window.addEventListener('hashchange', this.handleHrefChange)
  }

  componentWillUnmount() {
    window.addEventListener('hashchange', this.handleHrefChange)
  }

  handleHrefChange = () => {
    if (!location.hash.includes('overview')) {
      this.props.onClose()
    }
  }

  handleSave = () => {
    const { confStore, history } = this.props
    confStore.finishOffer(() => {
      const offer = confStore.getOffer
      if (offer.contactDetails.phone) {
        if (offer.planningReason === 'PROVISION') {
          history.push(`/planung/vorsorge/bestaetigung/${offer.uuid}`)
        } else {
          history.push(`/planung/abschluss/${offer.uuid}`)
        }
      } else {
        confStore.setContactDetailsPopup(true)
      }
    })
  }

  renderDiscounts() {
    const { confStore } = this.props
    const discounts = confStore.getDiscounts()
    return (
      <>
        {discounts.map((d, index) => {
          const discountValue = d.prices[0].amount / 100
          return (
            <SmallConfOverviewItem
              key={`discount-mobile-${index}`}
              bold
              style={{
                color: '#75b488'
              }}>
              <p>{d.shortDescription}</p>
              <NumberFormat
                value={discountValue}
                displayType='text'
                thousandSeparator='.'
                decimalSeparator=','
                prefix='- € '
                style={{ fontWeight: 'bold', fontSize: 18 }}
                decimalScale={2}
                fixedDecimalScale={!Number.isInteger(discountValue)}
              />
            </SmallConfOverviewItem>
          )
        })}
      </>
    )
  }

  renderButtons = () => {
    const { confStore } = this.props
    const offer = confStore.getOffer
    if (offer.orderConfirmed)
      return (
        <HighlightInBox
          style={{
            background: 'transparent',
            border: '5px solid #8dd691'
          }}>
          <p>
            <i className='fas fa-check' />{' '}
            <strong>Bestattung erfolgreich beauftragt</strong>
          </p>
          <p>
            Bei Änderungswünschen zur beauftragten Bestattung wenden Sie sich
            gerne jederzeit per E-Mail an{' '}
            <a href='mailto: kontakt@benu.at'>kontakt@benu.at</a> oder
            telefonisch unter <a href='tel:+4319076885'>01 907 68 85</a> an uns.
          </p>
        </HighlightInBox>
      )
    return (
      <>
        <Link onClick={this.handleSave}>Speichern & herunterladen</Link>
        <HintText>
          <i>Kostenlos und unverbindlich</i>
        </HintText>
      </>
    )
  }

  render() {
    const { confStore, open, onClose } = this.props

    const offer = confStore.getOffer

    const productTotalNoDiscount = confStore.offerProductTotalWithDiscounts()
    const feesTotal = confStore.offerFeesTotal()
    const grandTotal = confStore.offerGrandTotal()

    let financingInfo = null
    if (
      offer.planningReason === 'PROVISION' &&
      offer.provision.includeTrustAccountCosts
    )
      financingInfo = <FinancingProvision />
    else if (offer.planningReason !== 'PROVISION' && !offer.orderConfirmed)
      financingInfo = <Financing />

    return (
      <SlidingPanel
        isOpen={open}
        backdropClicked={onClose}
        type='bottom'
        size={92}>
        <Container>
          <Close href='#' onClick={onClose}>
            <i className='fas fa-times'></i>
            <p> Schließen</p>
          </Close>
          {this.renderDiscounts()}
          <SmallConfOverviewItem
            bold
            style={{
              textTransform: 'uppercase',
              paddingBottom: '5px',
              borderBottomWidth: '5px',
              borderBottomStyle: 'double',
              borderBottomColor: '#677D7F'
            }}>
            <p>Bestattungskosten</p>
            <NumberFormat
              value={productTotalNoDiscount}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              style={{ fontWeight: 'bold', fontSize: 18 }}
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(productTotalNoDiscount)}
            />
          </SmallConfOverviewItem>
          <SmallConfOverviewItem
            style={{
              fontStyle: 'italic',
              paddingTop: '10px'
            }}>
            <p>+ Gebührenschätzung *</p>
            <NumberFormat
              value={feesTotal}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              style={{ fontSize: 18 }}
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(feesTotal)}
            />
          </SmallConfOverviewItem>
          {offer.planningReason === 'PROVISION' &&
            offer.provision.includeTrustAccountCosts && (
              <SmallConfOverviewItem condense='true' italic='true'>
                <p>+ Einrichtung Treuhandkonto</p>
                <p>
                  <NumberFormat
                    value={99}
                    displayType='text'
                    thousandSeparator='.'
                    decimalSeparator=','
                    prefix='€ '
                  />
                </p>
              </SmallConfOverviewItem>
            )}
          <SmallConfOverviewItem
            style={{
              fontStyle: 'italic'
            }}>
            <p>Erwartete Gesamtkosten</p>
            <NumberFormat
              value={grandTotal}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              style={{ fontSize: 18 }}
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(grandTotal)}
            />
          </SmallConfOverviewItem>
          {this.renderButtons()}
          <VerticalAlignWrapper horizontalAlignment='space-between'>
            <p style={{ fontWeight: 'bold', fontSize: 17 }}>
              Gewählte Produkte:
            </p>
          </VerticalAlignWrapper>
          <ListOfProducts
            productsList={confStore.getSortedOfferProducts()}
            editable
          />
          <SmallHintText>
            Alle Preise verstehen sich inkl. der jeweils geltenden Umsatzsteuer.
            Externe Gebühren wie Verwaltungsgebühren etc. sind vom Angebot{' '}
            <u>nicht</u> umfasst.
          </SmallHintText>
          <VerticalAlignWrapper horizontalAlignment='space-around' margin={15}>
            <img
              src={
                offer.planningReason === 'PROVISION'
                  ? funeralHomeCertificate
                  : bestPriceGuaranteed
              }
              width='105'
              alt='Staatlich geprüfter Bestatter'
            />
            <img src={trustedShop} width='85' alt='Trusted Shop' />
          </VerticalAlignWrapper>
          <VerticalAlignWrapper horizontalAlignment='center' margin={15}>
            <Star />
            <Star />
            <Star />
            <Star />
            <Star />
          </VerticalAlignWrapper>
          <VerticalAlignWrapper
            horizontalAlignment='center'
            margin='7.5px 7.5px 15px 7.5px'>
            <a
              href='https://www.benu.at/kundenbewertungen/'
              target='_blank'
              style={{ textDecoration: 'underline', color: '#4a4a4a' }}>
              2.100+ betreute Familien
            </a>
          </VerticalAlignWrapper>
          <Accordion title='Gebührenschätzung'>
            <SmallHintText>
              Dies ist eine unverbindliche Einschätzung der externen Kosten und
              Gebühren. Sie fallen unabhängig von der Planung einer Bestattung
              an und werden direkt von Benu von Behörden etc. an Sie
              weiterverrechnet.
            </SmallHintText>
            <ListOfProducts
              productsList={confStore.getOffer.externalFees}
              isExternalFee={true}
            />
            <SmallConfOverviewItem bold>
              <p>Gesamt</p>
              <NumberFormat
                value={feesTotal}
                displayType='text'
                thousandSeparator='.'
                decimalSeparator=','
                prefix='€ '
                style={{ fontWeight: 'bold', fontSize: 18 }}
                decimalScale={2}
                fixedDecimalScale={!Number.isInteger(feesTotal)}
              />
            </SmallConfOverviewItem>
          </Accordion>
          {financingInfo}
          <VerticalAlignWrapper
            horizontalAlignment='center'
            column
            margin='15px 0 0 0'>
            <PhoneNumber />
            <p style={{ textAlign: 'center', marginBottom: 60 }}>
              Wir sind jederzeit für <br /> Sie erreichbar!
            </p>
          </VerticalAlignWrapper>
        </Container>
      </SlidingPanel>
    )
  }
}

const Container = styled.div`
  padding: 30px;
  ${media.tablet`
    padding: 15px;
  `}
`

const Close = styled.a`
  position: absolute;
  display: flex;
  align-items: baseline;
  width: 60px;
  height: 30px;
  left: calc((100vw - 768px) / 2);
  top: calc(8% / 2);
  color: white;
  font-weight: bold;
  transform: translateY(-40%);
  cursor: pointer;

  &:hover,
  &:focused,
  &:visited {
    text-decoration: none;
    color: white;
  }

  i {
    padding-right: 7.5px;
  }

  ${media.tablet`
    left: 15px;
  `}
`

const SmallConfOverviewItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${(props) =>
    props.border
      ? 'border-bottom: 3px solid #677D7F; margin-bottom: 7.5px;'
      : ''}

  p {
    font-size: 17px;
    ${(props) => (props.bold ? 'font-weight: bold;' : '')}
  }
`

export default withRouter(MobileConfiguratorOverview)



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/MobileConfiguratorOverview.tsx